import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Card, Pagination} from 'antd';

import * as actions from '../redux/actions/index';
import HeatMap from "../charts/HeatMap";
import _ from "lodash";


class StateHeatCard extends Component {
  state = {
    page: 1,
    size: 25
  };

  render() {
    const onClick = (fips, dimension, isAlternate) => {
      this.props.actions.selectCounty(fips);

      if (dimension === 'fips') {
        this.props.actions.selectPage('county');
      }
      else if (dimension) {
        this.props.actions.selectField(dimension, isAlternate ? 'y' : 'x');
      }
    };

    return (
      <Card className="StateHeatCard" noHovering={true} loading={this.props.loading}>
        <h2 className="subtitle">
          {this.props.stateName || 'State'} Health Dimensions By County - {this.props.year}<br/>
          <svg width={14} height={8}><rect width={8} height={8} rx={4} ry={4} fill="#e00de0"></rect></svg>
          National Percentile Ranking for County Dimension and Year
        </h2>
        <HeatMap
          data={this.props.data}
          dict={this.props.dict}
          dimensions={this.props.dimensions}
          selectedId={this.props.selectedId}
          dimId={this.props.idField}
          dimLabel={this.props.labelField}
          dimX={this.props.xField}
          dimY={this.props.yField}
          year={this.props.year}
          page={this.state.page}
          size={this.state.size}
          onClick={onClick}
        />
        <Pagination
          size="small"
          style={{position: 'absolute', bottom: 50, right: 120}}
          showSizeChanger
          pageSize={this.state.size}
          current={this.state.page}
          total={_.size(this.props.data)}
          pageSizeOptions={['10', '25', '50', '100']}
          onChange={(page, size) => this.setState({page, size})}
          onShowSizeChange={(current, size) => this.setState({size})}
        />
      </Card>
    );
  }
}

function mapStoreToProps(store, props) {
  return {
    loading: store.counties.loadingPct || store.dimensions.loading,
    data: store.counties.percentiles,
    dict: store.counties.dict,
    dimensions: store.dimensions.fields,
    stateName: store.states.selected.name,
    selectedId: store.counties.selected.fips,
    idField: store.dimensions.countyKey,
    labelField: store.dimensions.countyNameKey,
    xField: store.dimensions.xField,
    yField: store.dimensions.yField,
    xLabel: store.dimensions.xLabel,
    yLabel: store.dimensions.yLabel,
    xDesc: store.dimensions.xDesc,
    yDesc: store.dimensions.yDesc,
    year: store.dimensions.year
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStoreToProps, mapDispatchToProps)(StateHeatCard);



// WEBPACK FOOTER //
// ./src/containers/StateHeatCard.js